import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "title-separator" }
const _hoisted_2 = { class: "title" }
const _hoisted_3 = { id: "comingSoonSection" }
const _hoisted_4 = { class: "sectionContainer" }
const _hoisted_5 = { class: "sectionContent graphicRight" }
const _hoisted_6 = { class: "sectionText" }
const _hoisted_7 = { class: "sectionContent graphicLeft" }
const _hoisted_8 = { class: "sectionText" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("h3", _hoisted_2, _toDisplayString(_ctx.$t("ComingSoon")), 1)
    ]),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("p", null, _toDisplayString(_ctx.$t("ComingSoonText")), 1),
            _createElementVNode("ul", null, [
              _createElementVNode("li", null, _toDisplayString(_ctx.$t("ComingSoon1")), 1),
              _createElementVNode("li", null, _toDisplayString(_ctx.$t("ComingSoon2")), 1),
              _createElementVNode("li", null, _toDisplayString(_ctx.$t("ComingSoon3")), 1)
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_7, [
          _createElementVNode("div", _hoisted_8, [
            _createElementVNode("ul", null, [
              _createElementVNode("li", null, _toDisplayString(_ctx.$t("ComingSoon4")), 1),
              _createElementVNode("li", null, _toDisplayString(_ctx.$t("ComingSoon5")), 1),
              _createElementVNode("li", null, _toDisplayString(_ctx.$t("ComingSoon6")), 1)
            ])
          ])
        ])
      ])
    ])
  ], 64))
}